<template>
    <div class="container-fluid">
        <!-- Row 1: Client & Request -->
        <div class="row">
            <div class="col-md-6 mb-3">
                <label class="d-block">
                    <span class="form-label">Client</span>
                    <client-ac 
                        v-model="form.CustomerNumber" 
                        inputclass="form-control form-control-sm"
                        placeholder="Search for a client..."
                    ></client-ac>
                </label>
            </div>
            <div class="col-md-6 mb-3">
                <label class="d-block">
                    <span class="form-label">Request/Job</span>
                    <job-ac 
                        v-model="form.RequestId" 
                        :client="form.CustomerNumber"
                        :pm-only="pmOnly"
                        placeholder="Search for a request..."
                    ></job-ac>
                </label>
            </div>
        </div>

        <!-- Row 2: Assigned To & Expense Amount -->
        <div class="row">
            <div class="col-md-6 mb-3">
                <label class="d-block">
                    <span class="form-label">Assigned To</span>
                    <tech-ac 
                        v-model="form.AssignedTo" 
                        placeholder="Search for a technician..."
                    ></tech-ac>
                </label>
            </div>
            <div class="col-md-6 mb-3">
                <label class="d-block">
                    <span class="form-label">Expense Amount</span>
                    <input
                        type="number"
                        step="0.01"
                        class="form-control form-control-sm"
                        v-model="form.ExpenseAmount"
                        placeholder="0.00"
                    />
                </label>
            </div>
        </div>

        <!-- Row 3: Expense Date & Reimbursement Check -->
        <div class="row">
            <div class="col-md-6 mb-3">
                <label class="d-block">
                    <span class="form-label">Expense Date</span>
                    <input
                        type="date"
                        class="form-control form-control-sm"
                        v-model="form.ExpenseDate"
                    />
                </label>
            </div>
            <div class="col-md-6 mb-3">
                <label class="d-block">
                    <span class="form-label">Reimbursement Check Number</span>
                    <input
                        type="text" 
                        class="form-control form-control-sm"
                        v-model="form.ReimbursementCheckNum"
                        placeholder="Check Number"
                    />
                </label>
            </div>
        </div>

        <!-- Row 4: Expense Notes (full width) -->
        <div class="row">
            <div class="col-12 mb-3">
                <label class="d-block">
                    <span class="form-label">Expense Notes</span>
                    <textarea
                        class="form-control form-control-sm"
                        rows="4"
                        v-model="form.ExpenseNotes"
                        placeholder="Describe the expense..."
                    ></textarea>
                </label>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>

import ClientAc from "@/components/Clients/ClientAc.vue";
import JobAc from "@/components/Jobs/JobAc.vue";
import TechAc from "@/components/Techs/TechAc.vue";

import { ExpenseModel } from "@/models/ExpenseModel";

const props = defineProps({
    pmOnly: {
        type: Boolean,
        default: false
    }
});

const form = defineModel<ExpenseModel>({ 
    type: ExpenseModel, 
    default: new ExpenseModel()
});

</script>